import type { EventCategory } from './base';

export const PWAEvents = {
  PWA_INSTALL_PROMPT_SHOWN: {
    categories: ['analytics'] as EventCategory[],
    properties: {},
  },
  PWA_INSTALL_PROMPT_DISMISSED: {
    categories: ['analytics'] as EventCategory[],
    properties: {},
  },
  BOTTOM_NAV_ITEM_CLICKED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      destination: '' as string,
      labelKey: '' as string,
      isFab: false as boolean,
      role: '' as string,
    },
  },
  QR_CODE_PAGE_VIEWED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      hasCardId: false as boolean,
    },
  },
  EMPLOYEE_ORDERS_VIEWED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      orderCount: 0 as number,
      filter: '' as string,
    },
  },
  EMPLOYEE_ORDERS_REFRESHED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      orderCount: 0 as number,
    },
  },
} as const;
